export const usd = (n) =>
  new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: n >= 1000 ? 0 : 2,
  }).format(Number.isFinite(n) ? n : 0);

export const compact = (n) =>
  new Intl.NumberFormat("en-US", { notation: "compact", maximumFractionDigits: 1 }).format(
    Number.isFinite(n) ? n : 0,
  );

export const intFmt = (n) =>
  new Intl.NumberFormat("en-US").format(Math.round(Number.isFinite(n) ? n : 0));

export const pct = (n) => `${(Number.isFinite(n) ? n : 0).toFixed(1)}%`;

export const signedPct = (n) => {
  if (n == null || !Number.isFinite(n)) return "—";
  const sign = n > 0 ? "+" : "";
  return `${sign}${n.toFixed(1)}%`;
};

export const formatDateISO = (d) => {
  if (!d) return "—";
  // `toLocaleString` honors the browser's timezone automatically.
  // `timeZoneName: 'short'` appends the abbreviation (MDT / PDT / UTC / …)
  // so the viewer can tell at a glance which zone the timestamp is in.
  return new Date(d).toLocaleString("en-US", {
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
    timeZoneName: "short",
  });
};
